import axios from "axios";
import { API_ROOT } from "./api-config";

const domainURL = API_ROOT + "/getDomains";
const machineURL = API_ROOT + "/getModelAndCategoriesFromCache";
const transactionURL = API_ROOT + "/transaction";
const searchTransactionURL = API_ROOT + "/transactions";
const rbacURL = API_ROOT + "/getBusinessActivities?USER_ID=";
const uucURL = API_ROOT + "/getUserInfo?USER_ID=";
const dealerAccountURL = API_ROOT + "/getRelatedAccountDetails?accountId=";
const searchTransactionsURL = API_ROOT + "/transactions?";
const salesPersonNamesURL = API_ROOT + "/salesPersonNames?";
const storedDealerIdsURL = API_ROOT + "/dogMemberAccounts?parentDealerId=";
const storedParentDealerIdsURL = API_ROOT + "/dogLeadAccounts";
const parentDealerActIdURL = API_ROOT + "/getParentDealerActId?accountId=";
const translationURL = API_ROOT + "/translatedTerms?locale=";
const exportTxnsReportURL = API_ROOT + "/exportTransactions";
const exportTxnForBrowserDownload = API_ROOT + "/exportTxnForBrowserDownload";
const getTransactionsforReviewCountURL = API_ROOT + "/txnsForReviewCount";
const PAGE_NO = "pageNo=";
const PAGE_SIZE = "pageSize=";
const SORT_BY = "sortBy=";
const SORT_ORDER = "sortOrder=";
const PARENT_DEALER_ACCOUNT_ID = "parentDealerAccountID=";
const DEALER_ACCOUNT_ID = "dealerAccountID=";
const deleteTransactionURL = API_ROOT + "/transaction?txnIds=";
const userPreferencesURL = API_ROOT + "/user-preferences";
const transactionAttachmentURL = API_ROOT + "/attachments";
const viewEditTransactionURL = API_ROOT + "/transaction/";

const isProduction =
  window &&
  window.location &&
  window.location.hostname &&
  (window.location.hostname === require("../utils/config/keys").PROD_FRONTEND ||
    window.location.hostname ===
      require("../utils/config/keys").PROD_FRONTEND_TEMP);

const headers = (contentType = "application/json") => {
  let token = "";
  token = `Bearer ${getToken()}`;
  return {
    "Content-Type": contentType,
    Accept: "application/json",
    Authorization: token,
  };
};

export const getToken = () => {
  let idToken = localStorage.getItem("okta-token-storage");
  if (idToken) {
    idToken = JSON.parse(idToken);
    if (
      Object.keys(idToken).length !== 2 ||
      idToken.accessToken === undefined ||
      idToken.accessToken === ""
    ) {
      localStorage.setItem("okta-token-storage", "");
      redirectToLogin();
    } else {
      return idToken.accessToken.accessToken;
    }
  }
};

export const redirectToLogin = () => {
  localStorage.setItem("firstLogin", "true");
  window.location.assign("/");
};

export const getAllMachines = () => {
  return axios
    .get(machineURL, {
      headers: headers(),
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error while fetching Machines data", error);
    });
};

export const getDomainDetails = () => {
  return axios
    .get(domainURL, {
      headers: headers(),
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error("Error while fetching domain details", error);
    });
};

export const postTransactionDetails = (transactionReq, isSimulateMode) => {
  const validateRequest = isSimulateMode && isProduction;
  return axios
    .post(
      transactionURL + "?validateRequest=" + validateRequest,
      transactionReq,
      {
        headers: headers(),
      }
    )
    .then((response) => response.data);
};

export const postTransactionAttachmentsDetails = (
  formData,
  txnId,
  userId,
  isSimulateMode
) => {
  const validateRequest = isSimulateMode && isProduction;
  return axios
    .post(
      transactionAttachmentURL +
        "?validateRequest=" +
        validateRequest +
        "&txnId=" +
        txnId +
        "&userId=" +
        userId,
      formData,
      {
        headers: headers("multipart/form-data"),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching txn attachment details", error);
      });
};

export const deleteAttachments = (fileIds, txnId, isSimulateMode) => {
  const validateRequest = isSimulateMode && isProduction;
  return axios
    .delete(transactionAttachmentURL + "/" + txnId, {
      data: fileIds,
      params: {
        validateRequest: validateRequest,
      },
      headers: headers(),
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
        console.error("Error while fetching delete attachment details", error);
      });
};

export const putTransactionDetails = (
  transactionReq,
  isSimulateMode,
  txnId
) => {
  const validateRequest = isSimulateMode && isProduction;
  return axios
    .put(
      viewEditTransactionURL + txnId + "?validateRequest=" + validateRequest,
      transactionReq,
      {
        headers: headers(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching update txn details", error);
    });
};

export const postSearchTransactionDetails = (
  searchTransactionReq,
  isSimulateMode
) => {
  return axios
    .post(searchTransactionURL, searchTransactionReq, {
      headers: headers(),
    })
    .then((response) => response.data)
    .catch((error) => {
       console.error("Error while fetching search txn details", error);
    });
};

export const getBusinessActivities = (userId) => {
  return axios
    .get(rbacURL + userId, {
      headers: headers(),
    })
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching business activities details", error);
      });
};

export const getUserDetailsFromUUC = (userId) => {
  return axios
    .get(uucURL + userId, {
      headers: headers(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error While fetching user details ", error);
     });
};

export const getDealerAccountDetails = (accountId) => {
  return axios
    .get(dealerAccountURL + accountId, {
      headers: headers(),
    })
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching dealer account details", error);
      });
};

export const getSearchTransactions = async (searchFilter) => {
  try {
    const response = await axios.post(
      `${searchTransactionsURL}${PAGE_NO}${searchFilter.pageNo}&${PAGE_SIZE}${searchFilter.rowsPerPage}&${SORT_BY}${searchFilter.sortBy}&${SORT_ORDER}${searchFilter.sortOrder}`,
      searchFilter,
      {
        headers: headers(),
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSalesPersonNames = (
  dealerAccountID,
  parentDealerAccountID,
  createByUser
) => {
  return axios
    .get(
      salesPersonNamesURL +
        DEALER_ACCOUNT_ID +
        dealerAccountID +
        "&" +
        PARENT_DEALER_ACCOUNT_ID +
        parentDealerAccountID +
        "&createByUser=" +
        createByUser,

      {
        headers: headers(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching sales person details", error);
      });
};

export const getStoredDealerIds = async (
  parentDealerId,
  userId,
  isSalesPerson
) => {
  try {
    const userIdParam = userId
      ? isSalesPerson
        ? `&salesPersonId=${userId}`
        : `&createByUser=${userId}`
      : "";
    const response = await axios.get(
      `${storedDealerIdsURL}${parentDealerId}${userIdParam}`,
      {
        headers: headers(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching stored dealer ids:", error);
    throw error;
  }
};

export const getStoredParentDealerIds = () => {
  return axios
    .get(storedParentDealerIdsURL, {
      headers: headers(),
    })
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching parent account dealer details", error);
      });
};

export const getTransactionResponse = (txnId) => {
  return axios
    .get(viewEditTransactionURL + txnId, {
      headers: headers(),
    })
    .then((response) => response.data)
    .catch((error) => {
       console.error("Error while fetching txn details", error);
    });
};

export const getParentDealerAccountId = (accountId) => {
  return axios
    .get(parentDealerActIdURL + accountId, {
      headers: headers(),
    })
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching parent account dealer details", error);
      });
};

export const exportTxnToExcelApi = async (searchFilter) => {
  try {
    const response = await axios.post(exportTxnsReportURL, searchFilter, {
      responseType: "String",
      headers: headers(),
    });
    if (response.status === 204) {
      throw createCustomError("No transactions found.", response.status);
    }
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    throw error;
  }
};

export const exportTxnToExcelApiForLessTxn = async (searchFilter) => {
  try {
    const response = await axios.post(
      exportTxnForBrowserDownload,
      searchFilter,
      {
        responseType: "blob",
        headers: headers(),
      }
    );
    if (response.status === 200) {
      const blobUrl = URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "transactions.xlsx";
      link.click();
      URL.revokeObjectURL(blobUrl);
    } else if (response.status === 204) {
      throw createCustomError("No transactions found.", response.status);
    } else {
      throw createCustomError(
        "Something went wrong,Please try again later.",
        response.status
      );
    }
  } catch (error) {
    throw error;
  }
};

const createCustomError = (message, status) => {
  const error = new Error(message);
  error.status = status;
  return error;
};

export const deleteTransactionResponse = (txnId, isSimulateMode) => {
  const validateRequest = isSimulateMode && isProduction;
  return axios
    .delete(
      deleteTransactionURL + txnId + "&validateRequest=" + validateRequest,
      {
        headers: headers(),
      }
    )
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching delete txn details", error);
      });
};

export const getTxnsForReviewCount = (searchFilter) => {
  return axios
    .post(getTransactionsforReviewCountURL, searchFilter, {
      headers: headers(),
    })
    .then((response) => response.data)
    .catch((error) => {
        console.error("Error while fetching review count details", error);
      });
};

export const getTranslatedTexts = async (locale) => {
  try {
    const response = await axios.get(`${translationURL}${locale}`, {
      headers: headers(),
    });
    return response.data;
  } catch (error) {
    console.error("getTranslatedTexts API ", error);
    throw error;
  }
};

export const setUserPreferences = async (userPreference, isSimulateMode) => {
  const validateRequest = isSimulateMode && isProduction;
  if (validateRequest) {
    return {
      status: 200,
    };
  }
  try {
    const response = await axios.post(userPreferencesURL, userPreference, {
      headers: headers(),
    });
    return response;
  } catch (error) {
    console.error("setUserPreferences API ", error);
    throw error;
  }
};

export const fetchS3Attachment = async (fileLocation) => {
  try {
    return await axios.get(transactionAttachmentURL, {
      params: { fileLocation },
      headers: headers(),
      responseType: "blob",
    });
  } catch (error) {
    console.error("fetchS3Attachment  ", error);
    throw error;
  }
};
